import customAxios from "./axiosConfig";

const ProductGroupService = {
  create: function (data) {
    var url = window.Urls["productgroup-list"]();
    return customAxios.post(url, data)
  },
  list: function (params) {
    return customAxios.get(window.Urls["productgroup_list"](),  { params: params });
  },
  partial_update: function (id, data) {
    var url = window.Urls["productgroup-detail"](id);
    return customAxios.patch(url, data);
  },
  destroy: function(pk) {
    var url = window.Urls["productgroup-detail"](pk);
    return customAxios.delete(url);
  }
};

export default ProductGroupService ;